import { render, staticRenderFns } from "./LatestGamesPage.vue?vue&type=template&id=73e08292&scoped=true"
import script from "./LatestGamesPage.vue?vue&type=script&lang=js"
export * from "./LatestGamesPage.vue?vue&type=script&lang=js"
import style0 from "./LatestGamesPage.vue?vue&type=style&index=0&id=73e08292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e08292",
  null
  
)

export default component.exports